// Centralized pricing config for frontend UI.
// Mirrors backend/pricingConfig.js (keep amounts in sync).

export const PLAN_DEFINITIONS = {
  base_monthly: {
    key: 'base_monthly',
    planTier: 'base',
    billingInterval: 'monthly',
    amount: 199,
    currency: 'INR',
    savingsPct: 0,
    savingsLabel: '',
    billingLabel: 'Billed every month',
  },
  base_semiannual: {
    key: 'base_semiannual',
    planTier: 'base',
    billingInterval: 'semiannual',
    amount: Math.round(199 * 6 * 0.9),
    currency: 'INR',
    savingsPct: 10,
    savingsLabel: 'Save 10%',
    billingLabel: 'Billed every 6 months',
  },
  base_quarterly: {
    key: 'base_quarterly',
    planTier: 'base',
    billingInterval: 'quarterly',
    amount: Math.round(199 * 3 * 0.95),
    currency: 'INR',
    savingsPct: 5,
    savingsLabel: 'Save 5%',
    billingLabel: 'Billed every 3 months',
  },
  base_yearly: {
    key: 'base_yearly',
    planTier: 'base',
    billingInterval: 'yearly',
    amount: Math.round(199 * 12 * 0.8),
    currency: 'INR',
    savingsPct: 20,
    savingsLabel: 'Best value · Save 20%',
    billingLabel: 'Billed once a year',
  },
  pro_monthly: {
    key: 'pro_monthly',
    planTier: 'pro',
    billingInterval: 'monthly',
    amount: 399,
    currency: 'INR',
    savingsPct: 0,
    savingsLabel: '',
    billingLabel: 'Billed every month',
  },
  pro_semiannual: {
    key: 'pro_semiannual',
    planTier: 'pro',
    billingInterval: 'semiannual',
    amount: Math.round(399 * 6 * 0.9),
    currency: 'INR',
    savingsPct: 10,
    savingsLabel: 'Save 10%',
    billingLabel: 'Billed every 6 months',
  },
  pro_quarterly: {
    key: 'pro_quarterly',
    planTier: 'pro',
    billingInterval: 'quarterly',
    amount: Math.round(399 * 3 * 0.95),
    currency: 'INR',
    savingsPct: 5,
    savingsLabel: 'Save 5%',
    billingLabel: 'Billed every 3 months',
  },
  pro_yearly: {
    key: 'pro_yearly',
    planTier: 'pro',
    billingInterval: 'yearly',
    amount: Math.round(399 * 12 * 0.8),
    currency: 'INR',
    savingsPct: 20,
    savingsLabel: 'Best value · Save 20%',
    billingLabel: 'Billed once a year',
  },
};

export function planKey(planTier, billingInterval) {
  if (!planTier || !billingInterval) return null;
  return `${planTier}_${billingInterval}`;
}

export function getPlanConfig({ planTier, billingInterval, key }) {
  const k = key || planKey(planTier, billingInterval);
  if (!k) return null;
  return PLAN_DEFINITIONS[k] || null;
}

export function formatPrice(planTier, billingInterval) {
  const cfg = getPlanConfig({ planTier, billingInterval });
  if (!cfg) return '—';
  return `₹${cfg.amount.toLocaleString('en-IN')}`;
}

export function publicPricing() {
  return Object.values(PLAN_DEFINITIONS);
}

